export const setLanguages = (state, {languages}) => {
  state.languages = languages
}

export const setLoaded = (state, {loaded}) => {
  state.loaded = loaded
}

export const setLanguage = (state, {language}) => {
  localStorage.setItem('manifestLang', language)
  state.language = language
}



// WEBPACK FOOTER //
// ./src/store/destiny/manifest/mutations.js